export default __webpack_public_path__ + "static/media/DSC_0513.dfcd9f63.webp";